import { Flex, Icon, Text, Stack, CloseButton } from '@backyard-ui/core'
import { FrameOutline } from '@backyard-ui/icons'
import { byteToMegaByte } from 'frontendMyOrders/utils/formatters'

type AttachmentPreviewProps = {
  files: File[]
  onRemoveFile: (index: number) => void
}

const AttachmentPreview = (props: Readonly<AttachmentPreviewProps>) => {
  const { files, onRemoveFile } = props

  if (files.length < 1) {
    return null
  }

  return (
    <div className="bg-primary-100 min-h-14 max-h-full rounded-s-lg overflow-y-auto shadow-[0px_-10px_45px_0px_#00000024]">
      <Stack spacing={2} direction="column">
        {files.map((file, index) => (
          <Flex
            align="center"
            justify="space-between"
            key={index}
            className="w-full py-2 px-4"
            data-testid="attachment-content">
            <Stack align="center">
              <Flex
                align="center"
                justify="center"
                className="bg-primary-200 w-8 h-8 rounded-full">
                <Icon size="sm" UNSAFE_className="text-primary-700">
                  <FrameOutline />
                </Icon>
              </Flex>

              <Stack direction="column" spacing={1} data-testid="text">
                <Text color="neutral-900" size="sm">
                  {file.name}
                </Text>
                <Text color="neutral-900" size="sm">
                  {byteToMegaByte(file.size)}
                </Text>
              </Stack>
            </Stack>

            <Icon
              UNSAFE_className="text-primary-700"
              onClick={() => onRemoveFile(index)}
              data-testid="close-button">
              <CloseButton size="xs" />
            </Icon>
          </Flex>
        ))}
      </Stack>
    </div>
  )
}

export default AttachmentPreview
